import { ThemeEvents } from '@theme/events';

document.addEventListener(ThemeEvents.variantUpdate, (event) => {
  const available = event.detail.resource.available === true || event.detail.resource.available === 'true';
  const inStockText = document.querySelectorAll('.cstm-stock-status__text--in-stock');
  const outStockText = document.querySelectorAll('.cstm-stock-status__text--out-of-stock');
  const stockBlob = document.querySelectorAll(".cstm-stock-status .blob");

  if (inStockText.length === 0 && outStockText.length === 0) return;

  if (available) {
    inStockText.forEach(el => el.classList.add('show'));
    outStockText.forEach(el => el.classList.remove('show'));
    stockBlob.forEach(el => el.classList.remove('red'));
    stockBlob.forEach(el => el.classList.add('orange'));
  } else {
    inStockText.forEach(el => el.classList.remove('show'));
    outStockText.forEach(el => el.classList.add('show'));
    stockBlob.forEach(el => el.classList.add('red'));
    stockBlob.forEach(el => el.classList.remove('orange'));
  }
});

// Fix for not unique SVG gradient IDs when there are multiple of the same payment icons in the DOM
document.addEventListener("DOMContentLoaded", function() {
  const svgs = document.querySelectorAll('svg');

  svgs.forEach((svg, index) => {
      // Process both linearGradient and radialGradient
      const gradients = svg.querySelectorAll('linearGradient, radialGradient');
      
      gradients.forEach((gradient, gIndex) => {
          const newId = `pi-cstm-unique-paint${index}-${gIndex}`;
          
          const oldId = gradient.id;
          gradient.id = newId;
          
          // Update all references to this gradient
          const references = svg.querySelectorAll(`[fill="url(#${oldId})"], [stroke="url(#${oldId})"]`);
          references.forEach(ref => {
              ref.setAttribute('fill', `url(#${newId})`);
              ref.setAttribute('stroke', `url(#${newId})`);
          });
      });
  });
});

const cstmTimer = document.getElementById("cstmTimer");
if (cstmTimer) {
  const TOTAL_SECONDS = 3 * 24 * 60 * 60;
  function startCountdown() {
    let remaining = TOTAL_SECONDS;

    setInterval(() => {

      if (remaining <= 0) {
          remaining = TOTAL_SECONDS;
      }

      const days = Math.floor(remaining / (24 * 3600));
      const hoursTotal = Math.floor(remaining / 3600);
      const hoursMod = Math.floor((remaining % (24 * 3600)) / 3600);
      const minutes = Math.floor((remaining % 3600) / 60);
      const seconds = remaining % 60;

      const d = String(days).padStart(2, "0");
      const h = String(hoursTotal).padStart(2, "0");
      const m = String(minutes).padStart(2, "0");
      const s = String(seconds).padStart(2, "0");

      document.getElementById("cstmTimer").textContent =
          `${d}D ${h}U ${m}M ${s}S`;

      remaining--;
    }, 1000);
  }

  startCountdown();
}